import type {ReactElement} from 'react';
import React from 'react';
import {Icon} from '@Components/icon-v2';
import {IconSize} from '@Components/icon-v2/icon.types';
import {Text, TextSize} from '@Components/text';
import {Button, Size, Type} from '@Components/button';

interface LoadingErrorProps {
  onRefresh(): void;
}

export function LoadingError({...props}: LoadingErrorProps): ReactElement {
  return (
    <div className="flex-center flex-v-row _full-width _full-height">
      <div className="spacing-p-6 bg-danger-10 radius-round flex-center">
        <Icon icon="icon-exclamation-triangle" className="color-danger-100 spacing-m-0" size={IconSize.SIZE_ICON_32} />
      </div>
      <Text val={window.i18next.t('pmwjs_refresh_on_error')} size={TextSize.SMALL} className="content-body spacing-p-t-4 spacing-p-b-4" />
      <Button
        icon="icon-refresh"
        type={Type.SECONDARY}
        size={Size.SMALL}
        text={window.i18next.t('pmwjs_refresh')}
        onClick={(): void => {
          props.onRefresh();
        }}
      />
    </div>
  );
}
